export const adminHome = {
  view: 'Admin', 'admin.adminArea': 'home', 'admin.selectedUserId': null,
  'admin.selectedContractorId': null, accountTarget: null, snagId: null,
  captureOpen: false, reportOpen: false, auditProjectChooserOpen: false, snagProjectChooserOpen: false,
};

export function snagNeighbours(trail: string[], available: string[], current: string) {
  const allowed = new Set(available);
  const ids = [...new Set(trail)].filter((id) => allowed.has(id));
  const index = ids.indexOf(current);
  return { previous: index > 0 ? ids[index - 1] : undefined,
    next: index >= 0 ? ids[index + 1] : undefined, position: index + 1, total: ids.length };
}

export function swipeDirection(start: { x: number; y: number; time: number }, end: { x: number; y: number; time: number }) {
  const dx = end.x - start.x, dy = end.y - start.y, elapsed = end.time - start.time;
  if (elapsed < 0 || elapsed > 900 || Math.abs(dx) < 70 || Math.abs(dx) < Math.abs(dy) * 1.8) return null;
  return dx < 0 ? 'next' : 'previous';
}
